import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BusinessTrackerScreen from '@/screens/businessTracker/BusinessTrackerScreen';
import SalesmanDashboardScreen from '@/screens/businessTracker/SalesmanDashboardScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const BusinessTrackerNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="BusinessTrackerScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="BusinessTrackerScreen"
        component={BusinessTrackerScreen}
        options={{
          title: setTitleHeader('Business Tracker'),
        }}
      />
      <Stack.Screen
        name="SalesmanDashboardScreen"
        component={SalesmanDashboardScreen}
        options={{
          title: setTitleHeader('Business Tracker - Sales Activity'),
        }}
      />
    </Stack.Navigator>
  );
};

export default BusinessTrackerNavigator;
